// src/contexts/AuthContext.js

import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        // console.log('DEBUG: Token from storage:', token);
        if (token) {
            try {
                const decoded = jwtDecode(token);
                // console.log('Decoded token:', decoded);
                setUser({ id: decoded.user_id, username: decoded.username }); // Set user based on token's decoded data
            } catch (error) {
                console.error('Error decoding token:', error);
                localStorage.removeItem('token'); // Clear invalid token
            }
        }
        setLoading(false);
    }, []);

    const login = (token) => {
        // console.log("Logging in with token:", token);
        localStorage.setItem('token', token);
        const decoded = jwtDecode(token);
        // console.log("Decoded token:", decoded);
        setUser({ id: decoded.user_id, username: decoded.username });
    };
    
    const logout = () => {
        // console.log("Logging out...");
        localStorage.removeItem('token');
        setUser(null);
    };
    
    const contextValue = {
        user,
        login,
        logout,
        loading
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};
